import * as actions from "./actionsTypes";

const initialData = {
  loading: false,
  loadingById: false,
  saveLoading: false,
  metricByFactorsLength: 0,
  metricByFactors: [],
  metricByFactor: {},
  metricByFactorError: "",
  formError: "",
};

export default function MetricByFactorReducer(state = initialData,action) {
  switch (action.type) {
    case actions.LOADING_METRIC_BY_FACTOR:
      return { ...state, loading: action.payload };
    case actions.LOADING_METRIC_BY_FACTOR_BY_ID:
      return { ...state, loadingById: action.payload };
    case actions.SAVE_LOADING_METRIC_BY_FACTOR:
      return { ...state, saveLoading: action.payload };
    case actions.GET_METRIC_BY_FACTOR:
      return {
        ...state,
        metricByFactors: action.payload.metricByFactors,
        metricByFactorsLength: action.payload.metricByFactorsLength,
      };
    case actions.GET_METRIC_BY_FACTOR_BY_ID:
      return {
        ...state, metricByFactor: action.payload
      };
    case actions.FORM_FAIL:
      return { ...state, formError: action.payload };
    case actions.METRIC_BY_FACTOR_FAIL:
      return { ...state, metricByFactorError: action.payload };
    default:
      return state;
  }
}
